import { render } from "./DataPlatform.vue?vue&type=template&id=bef79f46"
import script from "./DataPlatform.vue?vue&type=script&lang=js"
export * from "./DataPlatform.vue?vue&type=script&lang=js"

import "./DataPlatform.vue?vue&type=style&index=0&id=bef79f46&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__